import React from 'react'
import { Employee } from '../../../Data/Employee'
import ScrollToTop from '../../ScrollToTop'
const About = () => {
    return (
        <div>
            <ScrollToTop />
            <div className="w-full h-40 flex justify-center items-center" style={{ background: '#f6f6f6' }}>
                <h1 className="text-4xl text-blk-txt">About Us</h1>
            </div>
            <div className="mt-5 flex flex-col items-center justify-center lg:px-16" data-aos="fade-up">
                <h2 className="text-lg text-blk-txt text-center py-2">Who We Are</h2>
                <p className="text-center text-sm text-ash py-2">Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Suspendisse potenti. Sed egestas, ante et vulputate volutpat, uctus metus libero eu augue. Morbi purus libero, faucibus adipiscing, commodo quis, gravida id, est. Sed lectus. Praesent elementum hendrerit tortor. Sed semper lorem at felis.</p>
                <img className="my-2" src="https://d-themes.com/react/molla/demo-1/images/about/about-2/signature.png" alt="" />

            </div>
            <div className="h-96 " data-aos="flip-right">
                <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src="https://i4.ypcdn.com/blob/550e9de0294d240d4466bf4b9859e423819f408e" alt="" className="w-full my-3" />

            </div>
            <div className="grid md:gap-2 md:grid-cols-3 my-4">
                <div className="w-full flex items-center justify-center flex-col" data-aos="fade-left">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 my-2 text-primary-txt" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                    </svg>
                    <h6 className="py-2 font-semibold text-blk-txt text-center">Design Quality</h6>
                    <p className="py-2 text-ash text-center w-72">Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero
                        eu augue.</p>
                </div>
                <div className="w-full flex items-center justify-center flex-col" data-aos="fade-down">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 my-2 text-primary-txt" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                    </svg>
                    <h6 className="py-2 font-semibold text-blk-txt text-center">Design Quality</h6>
                    <p className="py-2 text-ash text-center w-72">Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero
                        eu augue.</p>
                </div>
                <div className="w-full flex items-center justify-center flex-col" data-aos="fade-right">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 my-2 text-primary-txt" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                    </svg>
                    <h6 className="py-2 font-semibold text-blk-txt text-center">Design Quality</h6>
                    <p className="py-2 text-ash text-center w-72">Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero
                        eu augue.</p>
                </div>
            </div>
            <div className="my-4 w-full px-2">
                <h2 className="text-center text-blk-txt font-semibold text-3xl">Meet Our Team</h2>
                <div className="grid md:grid-cols-2 md:gap-2 lg:grid-cols-4 lg:gap-3 my-5">
                    {
                        Employee.map((item, index) => (
                            <div key={index} className="overflow-hidden  pb-3 shadow" data-aos={item.animation}>
                                <img src={item.img} className="h-56 w-full" alt="" style={{ objectFit: 'cover' }} />
                                <div className="px-3 text-center py-2">
                                    <p className="text-blk-txt font-semibold text-sm">{item.name}</p>
                                    <p className="text-xs text-ash">{item.position}</p>

                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default About
